<template>
  <div>
    <v-row>
      <v-col class="text-left" cols="8" md="10">
        <v-row class="general-domain-info" dense>
          <v-col class="border-right" cols="2">
            Status:
            <v-btn
                x-small
                dark
                :color="domain.status === 'active' ? 'green' : 'red' "
            >
              {{ domain.status }}
            </v-btn>
            <v-btn
                fab
                text
                small
                class="ma-2"
                :color="domain.status === 'active' ? 'red' : 'green' "
                @click="offerActivateDeactivate(item)"
            >
              <v-icon>
                mdi-power
              </v-icon>
            </v-btn>
          </v-col>
          <v-col class="border-right domain" cols="4">
            {{ domain.name }}
          </v-col>
          <v-col class="border-right" cols="2">
            Budget: <b>$ {{ domain.budget }} / day</b>
          </v-col>
          <v-col class="border-right" cols="2">
            O/U 7 : <b>{{ domain.ou7 }}%</b>
          </v-col>
          <v-col cols="2">
            O/U 30 : <b>{{ domain.ou30 }}</b>
          </v-col>
          <v-col class="border-top border-right" cols="2">
            Vertical: <b>{{ domain.verticalName }}</b>
          </v-col>
          <v-col class="border-top border-right" cols="2">
            Advertiser: <b>{{ domain.advertiserName }}</b>
          </v-col>
          <v-col class="border-top border-right" cols="2">
            Active Since: <b>2018-07-23</b>
          </v-col>
          <v-col class="border-top border-right" cols="2">
            Total Offers: <b>8</b>
          </v-col>
          <v-col class="border-top border-right" cols="2">
            Total Active Offers: <b>4</b>
          </v-col>
          <v-col class="border-top" cols="2">
            Total Inactive Offers: <b>4</b>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="4" md="2" class="py-0 d-flex flex-md-column align-center justify-space-around">
        <v-btn
            v-if="this.selected.length !== 0 && (user[0].can('manage_domains') || user[0].can('edit_domains_budget'))"
            color="error"
            @click="massDeactivateOffers()"
            width="200px"
            class="mass-action-button"
        >
          <i class="fas fa-power-off fa-2x"> </i>
          Mass Deactivate
        </v-btn>

        <v-btn
            v-if="this.selected.length !== 0 && (user[0].can('manage_domains') || user[0].can('edit_domains_budget'))"
            color="success"
            @click="massActivateOffers()"
            width="200px"
            class="mass-action-button"
        >
          <i class="fas fa-power-off fa-2x"> </i>
          Mass Activate
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
        v-model="selected"
        :headers="table.headersDomainItems"
        :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
        :items="domainItems"
        :loading="table.loading"
        :footer-props="{itemsPerPageOptions: table.pageOptions}"
        :page="table.currentPage"
        :items-per-page="table.perPage"
        loading-text="Loading... Please wait"
        :single-select="singleSelect"
        show-select
        item-key="offerId"
        fixed-header
        :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
        item-class="td_title"
        color="#7F98A5"
        :search="search"
    >
      <template v-slot:top>
        <DataTableTopBar @search="search" />
      </template>
      <template v-slot:item.offerStatus="{ item }">
          <span class="offer-status" v-if="item.offerStatus === 'private' || item.offerStatus === 'public' || item.offerStatus === 'apply_to_run'">
            <v-btn dark color='#358D83' class="btn-inner" >
                ACTIVE
            </v-btn>
          </span>
        <span class="offer-status" v-else-if="item.offerStatus === 'inactive'">
            <v-btn dark color="#C30628" class="btn-inner" >
                INACTIVE
            </v-btn>
          </span>

        <span class="offer-status" v-else-if="item.offerStatus === 'pending'">
            <v-btn dark color="#A9AC1D" class="btn-inner" >
                PENDING
            </v-btn>
          </span>

      </template>
      <template v-slot:item.actions="{item}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                fab
                text
                class="ma-2"
                :color="isActiveOffer(item) ? 'red' : 'green'"
                @click="offerActivateDeactivate(item)"
            >
              <v-icon large>
                mdi-power
              </v-icon>
            </v-btn>
          </template>
        </v-tooltip>

      </template>

    </v-data-table>
    <div class="loader-wrapper" v-if="loading">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>

  </div>
</template>

<script>
import MainLayout from "../../layouts/MainLayout"
import DataTableTopBar from '@/components/common/DataTableTopBar'
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import store from '../../../store'

export default {
  data() {
    return {
      domain: {
        name: '',
        status: '',
        verticalName: '',
        countOfOffers: 0,
        last7DaysAvg: 0,
        last30DaysAvg: 0,
        advertiserName: '',
        budget: 0
      },
      domainItems:[],
      budget:0,
      detailTab: {},
      domainId :this.$route.params.domain_id,
      singleSelect: false,
      selected: [],
      expanded: [],
      search: '',
      loading: false,
      showInactiveOffers: false,
      onlyRestricted: false,
      domainGroup: [],
      table: {
        heightCounter: 45,
        loading: false,
        searchInAffiliates: '',
        awaitingSearch: false,
        currentPage: 1,
        perPage: 25,
        pageChangedByMe: false,
        pageOptions: [10, 25, 50, 100],
        orderBy: '',
        sortColumnsAsc: true,
        headersDomainItems: [
          {text: 'id', value: 'offerId', align: 'center' },
          {text: 'Offers', value: 'offerName', align: 'center' },
          {text: 'Daily Avg. Lat 7 days', value: 'last7DaysAvg', align: 'center' },
          {text: 'Daily Avg. Lat 30 days', value: 'last30DaysAvg', align: 'center' },
          {text: 'Url', value: 'url', align: 'center', width: '680px'},
          {text: 'Status', value: 'offerStatus', align: 'center' },
          {text: 'Actions', value: 'actions', align: 'center' },
        ],
      }
    }
  },
  async created() {
    if (!this.user[0].can('manage_domains')
    ){
      await this.$router.push('/403');
    }
  },
  async mounted() {
    this.loading = true
    await store.dispatch('domains/saveDomainItemsStore',this.$route.params.domain_id)
    await store.dispatch('domains/saveDomainGroupStore', {})
    this.domainItems = this.getDomainItems
    const domainInfo = this.getDomainGroup.filter(i=>(i.id ===Number(this.domainId)));
    if (domainInfo.length !== 0) {
      this.domain.status = domainInfo[0].status
      this.domain.name = domainInfo[0].domainName
      this.domain.verticalName = domainInfo[0].verticalName
      this.domain.countOfOffers = domainInfo[0].countOfOffers
      this.domain.last7DaysAvg = domainInfo[0].last7DaysAvg
      this.domain.last30DaysAvg = domainInfo[0].last30DaysAvg
      this.domain.budget = domainInfo[0].budget
      this.domain.advertiserName = domainInfo[0].advertiserName
    }
    this.loading = false
  },
  components: {
    MainLayout,
    DataTableTopBar
  },
  watch: {
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('domains', [
      'getDomainItems','getDomainGroup'
    ]),
  },
  methods: {
    isActiveOffer(item){
      return item.offerStatus === 'public'
          || item.offerStatus === 'private'
          || item.offerStatus === 'pending'
          || item.offerStatus === 'apply_to_run'
    },
    async offerActivateDeactivate(item){
      const status = this.isActiveOffer(item) ? 'inactive' : 'pending'
      const data = []
      data.push(item)
      await this.massOffersStatusUpd(data, status)
    },
    async massActivateOffers(){
      const selectedItems = this.selected.filter(item=>(item.offerStatus === 'inactive'))
      await this.massOffersStatusUpd(selectedItems, 'pending')
    },
    async massDeactivateOffers(){
      const selectedItems = this.selected.filter(item=>(
          item.offerStatus === 'public'
          || item.offerStatus === 'pending'
          || item.offerStatus === 'private'
          || item.offerStatus === 'apply_to_run')
      )
      await this.massOffersStatusUpd(selectedItems,'inactive')
    },
    async massOffersStatusUpd(items, status){
      let offersIds = []
      let offersList = []
      items.forEach(i=>{
        offersIds.push({
          id:i.offerId
        })
        offersList.push(`${i.offerName}(${i.offerId})`)
      })

      if (offersIds.length ===0 ){
        await this.$dialog.info({
          title: `Info`,
          text: `all selected offers  already  ${status ==='pending'? 'activated': 'deactivated' }`
        })
        return
      }
      const masActivateMessage = `<p>Please note only your Account Manager can activate offers.</p> <p>The offers will become “Pending” and you Account Manager will be notified.</p>`
      const confirmDelOffer = await this.$dialog.warning({
        title: `You are about to ${status ==='pending'? 'activate': 'deactivate' } ${items.length} offers.`,
        text: `${offersList.join(',')} ${status === 'pending' && masActivateMessage} <p> Are you sure? </p>`
      })

      const data = {
        offersIds,
        status
      }
      if (confirmDelOffer){
        const resDb = await store.dispatch('domains/updateOfferStatus', data)
        if (resDb.success){
          await this.$dialog.notify.success(`Updated ${resDb.count} records `, {
            position: 'top-right',
            timeout: 2000
          })
          await this.updDomainItemsStatus(data)
        } else {
          await this.$dialog.notify.error(`Errors${resDb.error} records `, {
            position: 'top-right',
            timeout: 2000
          })
        }

      }
    },
    ...mapMutations('domains', ['updDomainItemsStatus']),
    ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),
  }
}
</script>

<style scoped lang="sass">
.green-color
  color: green
.red-color
  color: red
.general-domain-info
  background-color: #FFFFFF
  border-radius: 10px
  color: #3A3852
  font-size: 13px
  .col
    height: 50px
    display: flex
    align-items: center
    justify-content: space-between
  .border-right
    border-right: #E3EEF4 1px solid
  .border-top
    border-top: #E3EEF4 1px solid
  .domain
    font-size: 20px
    font-weight: 700
.mass-action-button
  width: 200px
  .v-btn__content
    justify-content: space-around
    min-width: 180px
</style>


